// WorkspaceSwitcher — the top of the sidebar: which workspace the chats below belong to.
// Own workspaces first, then the ones shared with you (with your role), then
// "New workspace…" and "Manage workspaces".

import { h, Component } from 'preact';
import { Orb } from './orb.js';
import { Icon } from './icons.js';

export const orbFor = (w) => (!w ? 'asleep'
  : ['PENDING', 'PROVISIONING'].includes(w.status) ? 'waking'
  : w.sleep_state === 'AWAKE' ? 'idle' : w.sleep_state === 'WAKING' ? 'waking' : 'asleep');

export const stateLabel = (w) => (!w ? ''
  : ['PENDING', 'PROVISIONING'].includes(w.status) ? 'Setting up…'
  : w.sleep_state === 'AWAKE' ? 'Awake' : w.sleep_state === 'WAKING' ? 'Waking…' : 'Asleep');

const ROLE = { owner: '', member: 'Member', viewer: 'Viewer' };

export class WorkspaceSwitcher extends Component {
  constructor(p) {
    super(p);
    this.state = { open: false, creating: false, name: '', busy: false, error: '' };
    this.root = null;
    this.onDoc = (e) => { if (this.state.open && this.root && !this.root.contains(e.target)) this.close(); };
    this.onKey = (e) => { if (e.key === 'Escape' && this.state.open) this.close(); };
  }
  componentDidMount() { document.addEventListener('mousedown', this.onDoc); document.addEventListener('keydown', this.onKey); }
  componentWillUnmount() { document.removeEventListener('mousedown', this.onDoc); document.removeEventListener('keydown', this.onKey); }
  close() { this.setState({ open: false, creating: false, name: '', error: '' }); }

  async create(e) {
    e.preventDefault();
    this.setState({ busy: true, error: '' });
    try {
      await this.props.onCreate(this.state.name.trim() || 'Workspace');
      this.setState({ busy: false }); this.close();
    } catch (err) { this.setState({ busy: false, error: err.message }); }
  }

  item(w) {
    const on = w.id === this.props.current;
    return h('button', { key: w.id, type: 'button', role: 'menuitemradio', 'aria-checked': on ? 'true' : 'false',
      className: 'ws-item' + (on ? ' on' : ''), onClick: () => { this.close(); this.props.onSwitch(w.id); } },
      h(Orb, { state: orbFor(w), size: 14 }),
      h('span', { className: 'ws-item-name' }, w.name || 'Workspace',
        w.role !== 'owner' ? h('small', null, w.owner_email ? `shared by ${w.owner_email}` : 'shared with you') : null),
      ROLE[w.role] ? h('span', { className: 'role-badge' }, ROLE[w.role]) : null,
      on ? h(Icon, { name: 'check', size: 14 }) : null);
  }

  render({ workspaces, current, max }, s) {
    const list = workspaces || [];
    const cur = list.find((w) => w.id === current);
    const own = list.filter((w) => w.role === 'owner');
    const shared = list.filter((w) => w.role !== 'owner');
    const full = max && own.length >= max;
    return h('div', { className: 'ws-switch', ref: (el) => { this.root = el; } },
      h('button', { type: 'button', className: 'ws-current', 'aria-haspopup': 'menu', 'aria-expanded': s.open ? 'true' : 'false',
        onClick: () => this.setState({ open: !s.open }) },
        h(Orb, { state: orbFor(cur), size: 22 }),
        h('span', { className: 'ws-current-text' },
          h('b', null, cur ? cur.name || 'Workspace' : (workspaces ? 'No workspace' : 'Loading…')),
          h('small', null, cur ? [stateLabel(cur), ROLE[cur.role] ? ` · ${ROLE[cur.role]}` : ''].join('') : '')),
        h('span', { className: 'chev', 'aria-hidden': 'true' })),
      s.open ? h('div', { className: 'ws-menu', role: 'menu' },
        own.length ? h('div', { className: 'ws-group' }, h('h5', null, 'Your workspaces'), own.map((w) => this.item(w))) : null,
        shared.length ? h('div', { className: 'ws-group' }, h('h5', null, 'Shared with you'), shared.map((w) => this.item(w))) : null,
        h('div', { className: 'ws-group ws-actions' },
          s.creating
            ? h('form', { className: 'ws-new', onSubmit: (e) => this.create(e) },
              h('input', { value: s.name, placeholder: 'Name, e.g. Client site', 'aria-label': 'New workspace name', maxLength: 64,
                ref: (el) => el && el.focus(), onInput: (e) => this.setState({ name: e.target.value }) }),
              h('button', { type: 'submit', className: 'btn primary', disabled: s.busy }, s.busy ? 'Creating…' : 'Create'))
            : h('button', { type: 'button', className: 'ws-item', disabled: full, title: full ? `You can have up to ${max} workspaces` : '',
              onClick: () => this.setState({ creating: true }) }, h(Icon, { name: 'plus', size: 14 }), h('span', { className: 'ws-item-name' }, 'New workspace',
                full ? h('small', null, `limit of ${max} reached`) : h('small', null, 'its own files, apps and bill'))),
          s.error ? h('p', { className: 'note err' }, s.error) : null,
          h('a', { className: 'ws-item', href: '/workspaces', onClick: () => this.close() }, h(Icon, { name: 'files', size: 14 }),
            h('span', { className: 'ws-item-name' }, 'Manage workspaces')))) : null);
  }
}
